export function isAdditionalStop({arrival, departure}: Pick<DbiApi.Train, 'arrival' | 'departure'>): boolean {
    return (
        (arrival as DbiApi.TrainStopTime).regStation === 'UmlNeu' ||
        (departure as DbiApi.TrainStopTime).regStation === 'UmlNeu'
    )
}
